import { Set } from 'immutable';
import { DateTime } from 'luxon';

import { mkUserinfo } from './userInfoTypes';

export function transformResponseToUserinfo(response: any) {
  const qUserinfo = response.data;
  return mkUserinfo({
    alwaysMfaMe: qUserinfo.alwaysMfaMe,
    defaultChannel: qUserinfo.defaultChannel,
    email: qUserinfo.email,
    entitlements: Set(qUserinfo.entitlements.split(',')),
    expiration: DateTime.fromMillis(qUserinfo.expiration).toISO(),
    groups: qUserinfo.groups, // web and mobile clients send groups string to 3rd parties - we rely on groups being a string
    id: 'me',
    phone: qUserinfo.phone,
    source: qUserinfo.source,
    tokenIssuedAt: DateTime.fromMillis(qUserinfo.tokenIssuedAt).toISO(),
    userCreatedAt: qUserinfo.userCreatedAt,
    userId: qUserinfo.userId,
    username: qUserinfo.username,
  });
}
